import { css } from 'styled-components';
var modalStyles = css(["", ";position:fixed;top:0px;left:0px;width:100%;height:100%;z-index:1050;overflow:hidden auto;text-align:center;background:rgba(0,0,0,0.5);cursor:pointer;.modal-inline{display:inline-block;text-align:left;}.modal-parent{position:relative;}"], function (props) {
  return props.inheritedStyles ? props.inheritedStyles : '';
});
export default modalStyles;